import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header } from './Header';
import {
    getFirstWeekDay,
    getLastWeekDay,
    convertTimestampToMomentObject,
    getFormattedDateFromMomentObject,
    getTimestampFromMoment,
    getFormattedDateFromDateObject,
} from '../../../../Utils/timeConvertorHelper';
import { AddClassModal } from '../../../Components/Modals/AddClassModal/AddClassModal';
import ModalContainer from '../../Modals/ModalContainer';
import { Loading } from '../../WithLoading/Loading';
import { EventComponent } from './Event';
import { HeaderCell } from './HeaderCell';
import { DaySummary } from './DaySummary';
import AddWorkoutChallengeModal from '../../../Components/Modals/AddWorkoutChallengeModal';
import { BirthdaysModal } from '../../../Components/Modals/BirthdaysModal';
import WeekCalendar from '../../../Components/WeekCalendar';
import { WorkoutActionCreators } from '../../../../Store/ActionCreators/WorkoutsActionCreators';
import { ClassesActionCreators } from '../../../../Store/ActionCreators/ClassesActionCreators';
import { MembersActionCreators } from '../../../../Store/ActionCreators/MembersActionCreators';
import { timeFormats } from '../../../../Constants/timeFormats';

class AdminPanelCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            weekSelected: 0,
            lastUid: 1,
            selectedIntervals: [],
            modalType: 0,
            isModalOpen: false,
            isAddClassModalOpen: false,
            isBirthdaysModalOpen: false,
            selectedWorkoutOfTheDayDate: null,
            selectedBdays: {},
            columnDimensions: [],
        };
    }

    componentDidMount() {
        const dates = this.getCurrentStartEndDate();
        this.props.getClassesByDateRange(dates.startDate, dates.endDate);

        const start = getFormattedDateFromMomentObject(
            getFirstWeekDay(this.state.weekSelected),
            timeFormats.SERVER_DATE_TYPE,
        );
        const end = getFormattedDateFromMomentObject(
            getLastWeekDay(this.state.weekSelected),
            timeFormats.SERVER_DATE_TYPE,
        );
        this.props.getWorkoutsOfTheDay(start, end);
        this.props.getMembersBirthdaysByDateRange(start, end);

        this.props.getWorkoutOfTheWeek(start);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.weekSelected !== this.state.weekSelected) {
            const dates = this.getCurrentStartEndDate();
            this.props.getClassesByDateRange(dates.startDate, dates.endDate);

            const start = getFormattedDateFromDateObject(
                getFirstWeekDay(this.state.weekSelected),
                timeFormats.SERVER_DATE_TYPE,
            );
            const end = getFormattedDateFromDateObject(
                getLastWeekDay(this.state.weekSelected),
                timeFormats.SERVER_DATE_TYPE,
            );
            this.props.getWorkoutsOfTheDay(start, end);
            this.props.getMembersBirthdaysByDateRange(start, end);

            this.props.getWorkoutOfTheWeek(start);
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.classes && nextProps.classes !== prevState.selectedIntervals) {
            const selectedIntervals = nextProps.classes.map(_class => {
                return {
                    ..._class,
                    start: convertTimestampToMomentObject(_class.start),
                    end: convertTimestampToMomentObject(_class.end),
                };
            });

            return { selectedIntervals };
        }
    }

    toggleAddClassModal = () => {
        this.setState({ isAddClassModalOpen: !this.state.isAddClassModalOpen });
    };

    getCurrentStartEndDate = () => {
        const { weekSelected } = this.state;
        const startDate = getFormattedDateFromDateObject(getFirstWeekDay(weekSelected), timeFormats.SERVER_DATE_TYPE);
        const endDate = getFormattedDateFromDateObject(getLastWeekDay(weekSelected), timeFormats.SERVER_DATE_TYPE);

        return {
            startDate,
            endDate,
        };
    };

    toggleAddWorkoutModal = (modalType, selectedWorkoutOfTheDayDate) => {
        this.setState({ modalType, selectedWorkoutOfTheDayDate }, () =>
            this.setState({ isModalOpen: !this.state.isModalOpen }),
        );
    };

    openBirthdaysModal = bDays => {
        this.setState({ selectedBdays: bDays }, () => {
            this.setState({ isBirthdaysModalOpen: true });
        });
    };

    closeBirthdaysModal = () => {
        this.setState({ selectedBdays: [], isBirthdaysModalOpen: false });
    };

    weekToggleHandlers = {
        toggleNextWeek: () => {
            this.setState({ weekSelected: this.state.weekSelected + 1 });
        },

        togglePreviousWeek: () => {
            this.setState({ weekSelected: this.state.weekSelected - 1 });
        },

        toggleToday: () => {
            this.setState({ weekSelected: 0 });
        },
    };

    calendarActions = {
        onIntervalRemove: event => {
            const { selectedIntervals } = this.state;
            const index = selectedIntervals.findIndex(interval => interval.uid === event.uid);
            if (index > -1) {
                selectedIntervals.splice(index, 1);
                this.setState({ selectedIntervals });
            }
        },

        onIntervalUpdate: event => {
            const { selectedIntervals } = this.state;
            const index = selectedIntervals.findIndex(interval => interval.uid === event.uid);
            if (index > -1) {
                selectedIntervals[index] = event;
                this.setState({ selectedIntervals });
            }
        },

        onIntervalSelect: newIntervals => {
            const { lastUid, selectedIntervals } = this.state;
            const intervals = newIntervals.map((interval, index) => {
                return {
                    ...interval,
                    uid: lastUid + index,
                };
            });

            this.setState({
                selectedIntervals: selectedIntervals.concat(intervals),
                lastUid: lastUid + newIntervals.length,
            });
        },
    };

    addWorkoutOfTheDay = (workoutId, cb) => {
        const { selectedWorkoutOfTheDayDate } = this.state;

        const requestObj = {
            workout_id: workoutId,
            date: selectedWorkoutOfTheDayDate,
        };

        this.props.addWorkoutOfTheDay(requestObj, cb);
    };

    addWorkoutOfTheWeek = (workoutId, cb) => {
        const { weekSelected } = this.state;
        const mondayDate = getFormattedDateFromDateObject(getFirstWeekDay(weekSelected), timeFormats.SERVER_DATE_TYPE);

        const requestObj = {
            workout_id: workoutId,
            date: mondayDate,
        };

        this.props.addWorkoutOfTheWeek(requestObj, cb);
    };

    getColumnDimensions = columnDimensions => {
        this.setState({ columnDimensions });
    };

    render() {
        const {
            state: {
                weekSelected,
                modalType,
                isModalOpen,
                selectedWorkoutOfTheDayDate,
                isAddClassModalOpen,
                isBirthdaysModalOpen,
                selectedBdays,
                columnDimensions,
            },
            props: {
                classesLoading,
                workoutsOfTheDay,
                workoutOfTheWeek,
                areWorkoutsOfTheDayLoading,
                birthdays,
                birthdaysLoading,
            },
            weekToggleHandlers,
            toggleAddWorkoutModal,
            calendarActions,
            addWorkoutOfTheDay,
            addWorkoutOfTheWeek,
            toggleAddClassModal,
            openBirthdaysModal,
            closeBirthdaysModal,
            getColumnDimensions,
        } = this;
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                {isModalOpen && (
                    <ModalContainer>
                        <AddWorkoutChallengeModal
                            type={modalType}
                            selectedDate={selectedWorkoutOfTheDayDate}
                            addWorkoutOfTheWeek={addWorkoutOfTheWeek}
                            addWorkoutOfTheDay={addWorkoutOfTheDay}
                            onClose={toggleAddWorkoutModal}
                        />
                    </ModalContainer>
                )}

                {isAddClassModalOpen && (
                    <ModalContainer>
                        <AddClassModal onClose={toggleAddClassModal} />
                    </ModalContainer>
                )}

                {isBirthdaysModalOpen && (
                    <ModalContainer>
                        <BirthdaysModal {...selectedBdays} onClose={closeBirthdaysModal} />
                    </ModalContainer>
                )}

                <Header
                    onToggleModal={toggleAddWorkoutModal}
                    onToggleClassModal={toggleAddClassModal}
                    weekSelected={weekSelected}
                    weekChallenge={workoutOfTheWeek}
                    {...weekToggleHandlers}
                />

                <Loading isLoading={classesLoading}>
                    <DaySummary
                        workoutsLoading={areWorkoutsOfTheDayLoading}
                        workoutsOfTheDay={workoutsOfTheDay}
                        birthdays={birthdays}
                        birthdaysLoading={birthdaysLoading}
                        weekSelected={weekSelected}
                        onToggleModal={toggleAddWorkoutModal}
                        toggleBirthdaysModal={openBirthdaysModal}
                        columnWidth={columnDimensions}
                    />

                    <WeekCalendar
                        {...calendarActions}
                        selectedIntervals={this.state.selectedIntervals}
                        eventSpacing={0}
                        firstDay={getFirstWeekDay(weekSelected)}
                        modalComponent={NewClassModal}
                        eventComponent={EventComponent}
                        headerCellComponent={HeaderCell}
                        passColumnDimensions={getColumnDimensions}
                        dayFormat={'ddd DD'}
                        cellHeight={60}
                        scaleUnit={60}
                    />

                    <div
                        style={{
                            height: '30px',
                            backgroundColor: '#0e0e0e',
                            width: '50px',
                            position: 'fixed',
                            bottom: 0,
                            zIndex: 100000,
                        }}
                    />
                </Loading>
            </div>
        );
    }
}

const NewClassModal = ({ onSave, onRemove, start, end, ...props }) => {
    const timeRange = {
        start: getTimestampFromMoment(start),
        end: getTimestampFromMoment(end),
    };

    return (
        <ModalContainer>
            <AddClassModal onClose={onSave} {...props} isEdit={props.id ? true : false} {...timeRange} />
        </ModalContainer>
    );
};

const mapStateToProps = ({
    members: {
        statuses: { birthdaysLoading },
        birthdays,
    },
    classes: {
        statuses: { classesLoading },
        classes,
    },
    workout: {
        statuses: { areWorkoutsOfTheDayLoading, isWorkoutOfTheWeekLoading },
        workoutsOfTheDay,
        workoutOfTheWeek,
    },
}) => ({
    classesLoading,
    classes,
    areWorkoutsOfTheDayLoading,
    isWorkoutOfTheWeekLoading,
    workoutsOfTheDay,
    workoutOfTheWeek,
    birthdays,
    birthdaysLoading,
});

const mapDispatchToProps = dispatch => ({
    getWorkoutsOfTheDay: (start, end) =>
        dispatch(WorkoutActionCreators.getWorkoutsOfTheDayByDateRangeRequest(start, end)),
    addWorkoutOfTheDay: (workoutData, callback) =>
        dispatch(WorkoutActionCreators.addWorkoutOfTheDayRequest(workoutData, callback)),
    getWorkoutOfTheWeek: mondayDate => dispatch(WorkoutActionCreators.getWorkoutOfTheWeekRequest(mondayDate)),
    addWorkoutOfTheWeek: (workoutData, callback) =>
        dispatch(WorkoutActionCreators.addWorkoutOfTheWeekRequest(workoutData, callback)),
    getClassesByDateRange: (startDate, endDate) =>
        dispatch(ClassesActionCreators.getClassesByDateRangeRequest(startDate, endDate)),
    getMembersBirthdaysByDateRange: (startDate, endDate) =>
        dispatch(MembersActionCreators.getMembersBirthdaysByDateRangeRequest(startDate, endDate)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdminPanelCalendar);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/index.js